export const addSpace = (num) => {
  if (num === "-") {
    return num;
  }
  num = parseFloat(num).toFixed(2);
  const numString = num.toString();
  const chunks = [];
  const numArr = numString.split(".");
  let intPart = numString;
  let decimalPart = "";

  if (numArr.length === 2) {
    intPart = numArr[0];
    decimalPart = numArr[1];
  }
  if (decimalPart === "") {
    decimalPart = "00";
  }
  while (intPart.length >= 4) {
    const chunk = intPart.slice(-3);
    chunks.push(chunk);
    intPart = intPart.toString().replace(chunk, "");
  }

  chunks.push(intPart);

  return decimalPart
    ? `${chunks.reverse().join(" ")}.${decimalPart}`
    : chunks.reverse().join(" ");
};

export const addSpaceWithoutFloat = (num) => {
  const chunks = [];

  let intPart = num.toString();

  while (intPart.length >= 4) {
    const chunk = intPart.slice(-3);
    chunks.push(chunk);
    intPart = intPart.toString().replace(chunk, "");
  }

  chunks.push(intPart);

  return chunks.reverse().join(" ");
};

export const isEmpty = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const twoDecimalPlaces = (num) => Math.trunc(num * 100) / 100;

const requestFieldsMap = new Map();
requestFieldsMap.set("dunning_date", "quoteDate");
requestFieldsMap.set("status", "status");
requestFieldsMap.set("ko_status", "status");
requestFieldsMap.set("request_count", "requestState");
requestFieldsMap.set("is_eligible_backfilling", "isEligibleBackfilling");
requestFieldsMap.set("closing_date", "closeDate");
requestFieldsMap.set("service", "service");
requestFieldsMap.set("is_call_for_tender", "isCallForTender");
requestFieldsMap.set("created_at", "createdAt");
requestFieldsMap.set("sub_cat_name", "subCategory");
requestFieldsMap.set("subcategory_name", "subCategory");
requestFieldsMap.set("quote_status", "quoteStatus");
requestFieldsMap.set("state", "state");
requestFieldsMap.set("type", "type");
requestFieldsMap.set("stage", "stage");
requestFieldsMap.set("platform", "platform");
requestFieldsMap.set("country", "country");
requestFieldsMap.set("category", "category");
requestFieldsMap.set("subCategory", "subCategory");
requestFieldsMap.set("transportTypes", "transport");
requestFieldsMap.set("code", "code");

export const getRequestFieldName = (key) => {
  return requestFieldsMap.get(key);
};

export const getCurrentStage = (id) => {
  switch (id) {
    case 3:
      return "MATCHING_QUOTE_SELECTED";
    case 4:
      return "TRANSPORT_ESTIMATED";
    case 5:
      return "MATCHING_QUOTE_VALIDATED";
    case 6:
      return "QUOTE_INVALIDATE";
    case 7:
      return "QUOTE_TRANSPORT_ESTIMATION_PENDING";
    case 8:
      return "MATCHING_QUOTE_VALIDATED_KICK_OFF";
    case 9:
      return "MATCHING_QUOTE_VALIDATED_OUT_KICK_OFF";
    default:
  }
  return "";
};

export const getAllocations = () => [
  { value: 0, label: "0%" },
  { value: 10, label: "10%" },
  { value: 20, label: "20%" },
  { value: 30, label: "30%" },
  { value: 40, label: "40%" },
  { value: 50, label: "50%" },
  { value: 60, label: "60%" },
  { value: 70, label: "70%" },
  { value: 80, label: "80%" },
  { value: 90, label: "90%" },
  { value: 100, label: "100%" },
];

export const columnHeader = (columns, columnList) => {
  const removeColumn = [];
  for (let i = 0; i < columns.length; i++) {
    if (!columnList.includes(columns[i].title)) {
      removeColumn.push(i);
    }
  }
  for (let i = removeColumn.length - 1; i >= 0; i--) {
    columns.splice(removeColumn[i], 1);
  }
  return columns;
};

export const textReplace = (text, oldWord, newWord) => {
  return text.toString().replace(oldWord, newWord);
};

export const renderPriceWithCurrency = (price, unit, currency, position) => {
  if (parseInt(position, 10) !== 1) {
    return `${currency} ${price} /${unit}`;
  }

  return `${price} ${currency}/${unit}`;
};

export const renderPriceWithCurrencyWithoutUnit = (
  price,
  currency,
  position
) => {
  if (parseInt(position, 10) !== 1) {
    return `${currency} ${price}`;
  }

  return `${price} ${currency}`;
};

export const getCenterProductPriceTypeOptions = (t) => {
  return [
    { label: t("TYPE"), value: "" },
    { label: t("CENTRE_PRODUCT_PRICE_TREATMENT"), value: 1 },
    { label: t("CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT"), value: 2 },
    { label: t("CENTRE_PRODUCT_PRICE_TRANSPORT"), value: 4 },
    { label: t("CENTRE_PRODUCT_PRICE_UNKNOWN"), value: 4 },
  ];
};

export const getCenterProductPriceCatchmentTypeOptions = (t) => {
  return [
    { label: t("TYPE"), value: "" },
    { label: t("NONE"), value: 0 },
    { label: t("CATCHMENT_AREA_RADIUS"), value: 1 },
    { label: t("CATCHMENT_AREA_DEPARTMENTS"), value: 2 },
    { label: t("CATCHMENT_AREA_ZONE"), value: 3 },
  ];
};

export const getValorisationRateOptions = [
  { label: "0%", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
  { label: "60%", value: 60 },
  { label: "70%", value: 70 },
  { label: "80%", value: 80 },
  { label: "90%", value: 90 },
  { label: "100%", value: 100 },
];

export const getWinningProbabilityOptions = [
  { label: "0%", value: 0 },
  { label: "25%", value: 10 },
  { label: "50%", value: 20 },
  { label: "75%", value: 30 },
  { label: "100%", value: 40 },
];

export const address = (countryId, address, countryListArray) => {
  const countryData = countryListArray.find((info) => info.id == countryId);
  let addressStr = "";
  const street = address.street ? address.street : "-";
  let postalCode = address?.postalCode ?? address?.zipcode;
  postalCode = !postalCode ? "-" : postalCode;
  const city = address.city ? address.city : "-";

  if (street === "-" && postalCode === "-" && city === "-") {
    return "-</br>" + countryData.label;
  }
  if ([2, 6, 8].includes(countryId)) {
    if (street !== "-") {
      addressStr = street;
    }
    if (street !== "-" && postalCode !== "-") {
      addressStr += "</br>";
    }
    if (postalCode !== "-") {
      addressStr += postalCode;
    }
    if (city !== "-") {
      addressStr += " " + city;
    }
    if (countryData.label) {
      addressStr += "</br>" + countryData.label;
    }
  } else {
    if (street !== "-") {
      addressStr = street;
    }
    if (street !== "-" && city !== "-") {
      addressStr += "</br>";
    }
    if (city !== "-") {
      addressStr += city;
    }
    if (postalCode !== "-") {
      addressStr += "" + postalCode;
    }
    if (countryData.label) {
      addressStr += "</br>" + countryData.label;
    }
  }
  return addressStr;
};

export const addressSingleLine = (countryId, address, countryListArray) => {
  const countryData = countryListArray.find((info) => info.id == countryId);
  let postalCode = address?.postalCode ?? address?.zipcode;
  postalCode = !postalCode ? "-" : postalCode;
  let addressStr = "";
  if ([2, 6, 8].includes(countryId)) {
    addressStr =
      address.street +
      " " +
      postalCode +
      " " +
      address.city +
      " " +
      countryData?.label;
  } else {
    addressStr =
      address.street +
      " " +
      address.city +
      " " +
      postalCode +
      " " +
      countryData?.label;
  }
  return addressStr;
};

export const addressSingleLineWithoutCountry = (countryId, address) => {
  let addressStr = "";
  const street = address.street ? address.street : "-";
  let postalCode = address?.postalCode ?? address?.zipcode;
  postalCode = !postalCode ? "-" : postalCode;
  const city = address.city ? address.city : "-";

  if (street === "-" && postalCode === "-" && city === "-") {
    return "-";
  }
  if ([2, 6, 8].includes(countryId)) {
    if (street !== "-" && street !== "") {
      addressStr = street;
    }
    if (street !== "-" && postalCode !== "-") {
      addressStr += ", ";
    }
    if (postalCode !== "-") {
      addressStr += postalCode;
    }
    if (city !== "-" && postalCode !== "") {
      addressStr += ", ";
    }
    if (city !== "-") {
      addressStr += city;
    }
  } else {
    if (street !== "-") {
      addressStr = street;
    }
    if (street !== "-" && city !== "-") {
      addressStr += ", ";
    }
    if (city !== "-") {
      addressStr += city;
    }
    if (city !== "-" && postalCode !== "-") {
      addressStr += ", ";
    }
    if (postalCode !== "-") {
      addressStr += postalCode;
    }
  }
  return addressStr;
};

export const getCountryByCode = (code, countryListArray) => {
  const countryData = countryListArray.find((info) => info.code === code);
  return countryData.id;
};

export const getCountryName = (selectedCountryId, countries) => {
  if (selectedCountryId) {
    const isCountryPresent = countries?.find(
      ({ id }) => parseInt(id, 10) === parseInt(selectedCountryId, 10)
    );
    if (isCountryPresent) {
      return isCountryPresent.label;
    }
  }
  return "";
};

export const getConvertedPrice = (currencyId, price, exchangeRates) => {
  const rateInfo = exchangeRates?.find(
    (rate) => rate.currencyFrom === currencyId
  );
  return rateInfo ? rateInfo?.exchangeRate * price : price;
};

export const filterUnit = (unit, t) => {
  const unitArray = [];
  if (["UNIT", "PACKAGE", "DAY", "HOUR"].indexOf(unit) !== -1) {
    unitArray.push({ label: t(unit), value: unit });
  }
  if (["TON", "M3"].indexOf(unit) !== -1) {
    unitArray.push({ label: t(unit), value: unit });
    unitArray.push({ label: t("LOAD"), value: "LOAD" });
  }
  if (["LOAD"].indexOf(unit) !== -1) {
    unitArray.push({ label: t("LOAD"), value: "LOAD" });
  }
  return unitArray;
};

export const updateUnitTranslation = (unitList, t) => {
  const unitArray = [];
  if (unitList?.length > 0) {
    unitList.map((unit) => {
      unitArray.push({ label: t(unit.label), value: unit.value });
    });
    return unitArray;
  }
  return unitList;
};

export const getSupportedLngs = (languageObj) => {
  const langArray = [];
  if (languageObj?.length > 0) {
    languageObj.map((langInfo) => {
      langArray.push(langInfo.lang);
    });
  }
  return langArray;
};
